import { useState } from "react";
import "keen-slider/keen-slider.min.css";

// Import Images
import GardenBedroom1 from "../Assets/accomodation/GardenView/garden-bedroom1.webp";
import GardenBedroom2 from "../Assets/accomodation/GardenView/garden-bedroom2.webp";
import GardenBathroom from "../Assets/accomodation/GardenView/garden-bathroom.webp";
import GardenEntrance from "../Assets/accomodation/GardenView/garden-entrance.webp";
import GardenFront from "../Assets/accomodation/GardenView/garden-front.webp";

import LakeView from "../Assets/accomodation/LakeView/lakeview.webp";
import LakeViewBedroom from "../Assets/accomodation/LakeView/lakeview-bedroom.webp";
import LakeViewBathroom from "../Assets/accomodation/LakeView/lakeview-bathroom.webp";

import SuiteBalcony1 from "../Assets/accomodation/LakeViewSuite/suite-balcony1.webp";
import SuiteBalcony2 from "../Assets/accomodation/LakeViewSuite/suite-balcony2.webp";
import SuiteBathroom from "../Assets/accomodation/LakeViewSuite/suite-bathroom.webp";
import SuiteBedroom1 from "../Assets/accomodation/LakeViewSuite/suite-bedroom1.webp";
import SuiteBedroom2 from "../Assets/accomodation/LakeViewSuite/suite-bedroom2.webp";
import SuiteBedroomBalcony from "../Assets/accomodation/LakeViewSuite/suite-bedroom-balcony.webp";
import SuiteCorridor from "../Assets/accomodation/LakeViewSuite/suite-corridor.webp";
import LazyLoadCarousel from "../component/LazyLoadCarousel";


// Room Data
const rooms = [
  {
    name: "Garden View Room",
    description:
      "Wake up to the gentle rustle of leaves and the fragrance of fresh blooms. Our Garden View Rooms offer a peaceful retreat, with windows framing lush greenery and manicured landscapes. Interiors feature earthy tones, cozy furnishings, and modern amenities to ensure your stay is both relaxing and rejuvenating.",
    images: [
      GardenEntrance,
      GardenFront,
      GardenBedroom1,
      GardenBedroom2,
      GardenBathroom,
    ],
  },
  {
    name: "Lake View Room",
    description:
      "Enjoy breathtaking views of the shimmering lake right from your window. Designed for tranquility and comfort, our Lake View Rooms let you witness stunning sunrises and moonlit waters. With elegant interiors, premium bedding, and abundant natural light, they offer the perfect mix of beauty and luxury.",
    images: [LakeView, LakeViewBedroom, LakeViewBathroom],
  },
  {
    name: "Lake View Suite",
    description:
      "Indulge in spacious luxury with our Lake View Suites, where every corner is designed for elegance. Featuring separate living areas, plush bedding, and private balconies with sweeping lake views, these suites are ideal for romantic getaways or extended stays. Enjoy high-end amenities, stylish décor, and an unmatched atmosphere of comfort.",
    images: [
      SuiteBalcony1,
      SuiteBalcony2,
      SuiteBathroom,
      SuiteBedroom1,
      SuiteBedroom2,
      SuiteBedroomBalcony,
      SuiteCorridor,
    ],
  },
];


export default function Accommodation() {
  const [popupImage, setPopupImage] = useState(null);

  return (
    <div className="min-h-screen bg-[rgb(6,48,23)] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight mb-4">
            Accommodations For You
          </h1>
          <p className="text-base sm:text-lg text-gray-200 max-w-3xl mx-auto">
            Experience comfort and scenic beauty in our carefully curated rooms,
            designed to give you unforgettable stays amidst nature.
          </p>
        </div>

        {/* Rooms */}
        {rooms.map((room, i) => (
          <div key={i} className="mb-12 sm:mb-20">
            <h2 className="text-2xl sm:text-3xl font-bold mb-3">{room.name}</h2>
            <p className="text-sm sm:text-base text-gray-300 mb-6 max-w-5xl">
              {room.description}
            </p>
            <LazyLoadCarousel images={room.images} onImageClick={setPopupImage} />
          </div>
        ))}
      </div>

      {/* Popup */}
      {popupImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4"
          onClick={() => setPopupImage(null)}
        >
          <div className="relative">
            <img
              src={popupImage}
              alt="Room Preview"
              className="max-w-[90vw] max-h-[80vh] sm:max-h-[90vh] rounded-lg shadow-2xl"
              loading="lazy"
            />
            <button
              className="absolute top-3 right-3 bg-white/80 hover:bg-white text-black rounded-full p-2 shadow-lg transition"
              onClick={() => setPopupImage(null)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
}